import moment from 'moment';

export const formatTimestamp = (ts: string | number, format = 'MMM DD, YYYY HH:mm:ss') => (
    <>
        {moment(ts)
            .format(format)}
    </>
);
